import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarContainerComponent } from './sidebar-container/sidebar-container.component';
import { MarkantElementsModule } from '@markant/elements-angular';
import { RouterLink, RouterOutlet } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { BreadcrumbComponent } from '@markant-platform/shared/breadcrumb/feature';

@NgModule({
  imports: [
    CommonModule,
    MarkantElementsModule,
    BreadcrumbComponent,
    RouterOutlet,
    RouterLink,
    TranslocoModule,
    RouterLink,
  ],
  declarations: [SidebarContainerComponent],
  exports: [SidebarContainerComponent],
})
export class SharedSidebarContainerFeatureModule {}
